import { getFirestore, collection, addDoc, query, where, getDocs, getDoc, updateDoc, doc, orderBy, DocumentData } from "firebase/firestore";
import { logError, removeToCartData, updateOrdersList, updateOrdersReport, updatedRoomBills } from "@src/app/actions/userActions";
import { getNextOrderSeqNo } from "@src/utilities/orderSequence";
import moment from 'moment';

const ordersCollectionName = "orders";
const roomBillsCollectionName = "room-bills";

export const submitOrder = async (data: any, dispatch: any, navigate: any, restaurantId: any, tableNumber?: any, type?: any) => {
    const db = getFirestore();
    // console.log('=====', data);
    try {
        if (!!data) {
            const isGstBill = !!data.isGstBill;
            const seqFields = isGstBill
                ? await getNextOrderSeqNo(restaurantId, 'FD', data.createdAt)
                : {};
            const docRef = await addDoc(collection(db, ordersCollectionName), {
                ...data,
                restaurantId,
                ...seqFields,
            });
            console.log("Order written with ID: ", docRef.id);
            if (docRef.id) {
                dispatch(removeToCartData({}, tableNumber, restaurantId));
                // navigate(`/orders/${docRef.id}`);
                if (type === "admin" && restaurantId) {
                    // console.log('bg---', restaurantId)
                    navigate(`/admin/${restaurantId}/orders`);
                } else {
                    navigate(`/orders`);
                }
                return true;
            }
        }
        // dispatch(remove(null));
        return false;
    } catch (error: any) {
        console.error("Error adding document: ", error);
        dispatch(logError({ severity: 'error', message: error?.message }));
        return false;
    }
}


export const getOrdersList = async (role: any, filterId: any, dispatch: any, filter?: any) => {
    // console.log(role, filterId);
    const db = getFirestore();
    try {
        let data: DocumentData[] = [];

        if (filterId) {
            const isRangeFilter =
                filter &&
                typeof filter === 'object' &&
                filter?.type === 'range' &&
                filter?.startDate &&
                filter?.endDate;

            let q;

            if (isRangeFilter) {
                const start = moment(filter.startDate).startOf('day').utc().valueOf();
                const end = moment(filter.endDate).endOf('day').utc().valueOf();

                q = query(
                    collection(db, ordersCollectionName),
                    where(role === 'admin' ? "restaurantId" : "userId", "==", filterId),
                    where("createdAt", ">=", start),
                    where("createdAt", "<=", end),
                    orderBy("createdAt", "desc"),
                );
            } else {
                const days = typeof filter === 'number' ? filter : undefined;
                const endDate = moment().subtract(role === 'admin' ? days || 5 : days || 30, 'days').utc().valueOf();

                q = query(
                    collection(db, ordersCollectionName),
                    where(role === 'admin' ? "restaurantId" : "userId", "==", filterId),
                    where("createdAt", ">=", endDate),
                    orderBy("createdAt", "desc"),
                );
            }

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                // data.docId = doc.id || null;
                data.push({ ...doc.data(), orderId: doc.id });
            });
            // console.log('data block--', data);
            // data = querySnapshot && querySnapshot[0] && querySnapshot[0].data() || {};
            if (data && data.length) {
                dispatch(updateOrdersList(data));
            } else {
                dispatch(updateOrdersList([]));
            }
        }
        // console.log("data => sign In after", querySnapshot, data);
        // history.push('/');
        // return data;
        // dispatch(updateReqData(data));
    } catch (error: any) {
        console.error("Error getting document: ", error);
        dispatch(logError({ severity: 'error', message: error?.message }));
    }
}

const getFullAddress = (address: any) => {
    return (!!address?.type) ? address?.type + ': ' + address?.street + ', ' + address?.city + ', ' + address?.state : '';
}

export const getOrdersReport = async (role: any, filterId: any, dispatch: any, startDate: any, endDate: any, isGstBill: any, reportType: string) => {
    // console.log('startDate, endDate, isGstBill', startDate, endDate, isGstBill);
    const db = getFirestore();
    const reportCollectionName = (reportType === 'food') ? ordersCollectionName : roomBillsCollectionName;
    try {
        let data: DocumentData[] = [];
        // const endDate = moment().subtract(role === 'admin' ? 2 : 30, 'days').utc().valueOf()
        if (filterId && startDate && endDate) {
            const q = query(collection(db, reportCollectionName), where(role === 'admin' ? "restaurantId" : "userId", "==", filterId), where("createdAt", ">=", startDate), where("createdAt", "<=", endDate), where("isGstBill", "==", !!isGstBill), orderBy("createdAt", "desc"));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc: any) => {
                // doc.data() is never undefined for query doc snapshots
                // data.docId = doc.id || null;
                const formattedDate = moment(doc?.data()?.createdAt || '').format('D-MMM-YYYY, h:mm:ss a');
                // console.log('--date', doc?.data().createdAt, formattedDate);
                if (reportType === 'food') {
                    data.push({ ...doc?.data(), orderId: doc.id, user: null, ...doc?.data()?.user, orderStatus: doc?.data()?.orderStatus?.value, ...doc?.data()?.restaurant, tabs: null, selectedAddress: getFullAddress(doc?.data()?.selectedAddress), createdAt: formattedDate });
                } else {
                    const docData = doc?.data();
                    data.push({
                        ...docData,
                        orderId: doc.id,
                        createdAt: formattedDate,
                        rooms: Array.isArray(docData?.rooms)
                            ? docData.rooms.map((room: any) => ({ ...room }))
                            : docData?.rooms,
                        identificationFiles: Array.isArray(docData?.identificationFiles)
                            ? [...docData.identificationFiles]
                            : docData?.identificationFiles,
                    });
                }
            });
            // console.log('data block--', data);
            // data = querySnapshot && querySnapshot[0] && querySnapshot[0].data() || {};
            if (data && data.length) {
                // console.log('data', data);
                dispatch(updateOrdersReport(data));
            } else {
                dispatch(updateOrdersReport([]));
            }
        }
        // console.log("data => sign In after", querySnapshot, data);
        // history.push('/');
        // return data;
        // dispatch(updateReqData(data));
    } catch (error: any) {
        console.error("Error adding document: ", error);
        dispatch(logError({ severity: 'error', message: error?.message }));
    }
}

export const updateOrderStatus = async (orderId: any, data: any) => {
    const db = getFirestore();
    await updateDoc(doc(db, ordersCollectionName, orderId), {
        orderStatus: data
    });
}

export const updateOrderPayment = async (orderId: any, data: any) => {
    const db = getFirestore();
    await updateDoc(doc(db, ordersCollectionName, orderId), {
        selectedPayment: data
    });
}

export type OrderBillUpdate = {
    cart: Record<string, unknown>;
    itemsCost: number;
    gstBill: number;
    gstData: Record<string, number>;
    serviceBill: number;
    totalCost: number;
};

export const updateOrderBill = async (
    orderId: string,
    billUpdate: OrderBillUpdate,
    dispatch?: any
): Promise<boolean> => {
    const db = getFirestore();
    try {
        await updateDoc(doc(db, ordersCollectionName, orderId), billUpdate);
        dispatch?.(
            logError({ severity: 'success', message: 'Order bill updated successfully' })
        );
        return true;
    } catch (error: any) {
        console.error('Error updating order bill: ', error);
        dispatch?.(
            logError({
                severity: 'error',
                message: error?.message || 'Failed to update order bill',
            })
        );
        return false;
    }
};

export const linkFoodBillsList = async (orderId: string, resId: string, roomNumArr: string[], startDate: any, endDate: any, isGstBill: any) => {
    const db = getFirestore();

    try {
        let data: DocumentData[] = [];
        // const endDate = moment().subtract(role === 'admin' ? 2 : 30, 'days').utc().valueOf()
        // console.log(resId, startDate, endDate, roomNumArr)
        if (resId && startDate && endDate) {
            const q = query(
                collection(db, ordersCollectionName),
                where("restaurantId", "==", resId),
                where("tableNumber", "in", roomNumArr),
                where("isGstBill", "==", !!isGstBill),
                where("createdAt", ">=", moment(startDate).utc().valueOf()),
                where("createdAt", "<=", moment(endDate).utc().valueOf()),
                orderBy("createdAt", "desc"));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc: any) => {
                // doc.data() is never undefined for query doc snapshots
                // data.docId = doc.id || null;
                const formattedDate = moment(doc?.data()?.createdAt || '').format('D-MMM-YYYY, h:mm:ss a');
                // console.log('--date', doc?.data().createdAt, formattedDate);
                data.push({
                    orderId: doc?.id,
                    uid: doc?.data()?.user?.uid,
                    cart: doc?.data()?.cart,
                    uoId: doc?.data()?.uoId || doc?.id,
                    orderStatus: doc?.data()?.orderStatus?.value,
                    restaurantId: doc?.data()?.restaurant?.docId,
                    createdAt: formattedDate,
                    discount: doc?.data()?.discount,
                    gstBill: doc?.data()?.gstBill,
                    gstData: doc?.data()?.gstData,
                    gstRate: doc?.data()?.gstRate,
                    isGstBill: doc?.data()?.isGstBill,
                    itemsCost: doc?.data()?.itemsCost,
                    serviceBill: doc?.data()?.serviceBill,
                    serviceRate: doc?.data()?.serviceRate,
                    tableNumber: doc?.data()?.tableNumber,
                    totalCost: doc?.data()?.totalCost,

                });
            });
            // console.log('data food biils--', data);
            await updateDoc(doc(db, roomBillsCollectionName, orderId), {
                foodBills: data
            });
            return data;
            // data = querySnapshot && querySnapshot[0] && querySnapshot[0].data() || {};
            // if(data && data.length){
            //     // console.log('data', data);
            //     dispatch(updateOrdersReport(data));
            // } else {
            //     dispatch(updateOrdersReport([]));
            // }
        }
        // console.log("data => sign In after", querySnapshot, data);
        // history.push('/');
        // return data;
        // dispatch(updateReqData(data));
    } catch (error: any) {
        console.error("Error adding document: ", error);
        // dispatch(logError({ severity: 'error', message: error?.message }));
    }
    // await updateDoc(doc(db, ordersCollectionName, orderId), {
    //     selectedPayment: data
    // });
}

export const updateRoomOrderPayment = async (orderId: any, data: any) => {
    const db = getFirestore();
    await updateDoc(doc(db, roomBillsCollectionName, orderId), {
        selectedPayment: data
    });
}

export const updateCollData = async (collectionName: string, docId: string, keyPair: string, updatedData: any) => {
    // console.log('collectionName, docId, keyPair, updatedData', collectionName, docId, keyPair, updatedData);
    if(collectionName && docId && keyPair && updatedData !== undefined && updatedData !== null) {
        const db = getFirestore();
        await updateDoc(doc(db, collectionName, docId), {
            [keyPair]: updatedData
        });
    } else {
        console.log("something missing...");
    }
}

/** Partial update applied to the original food order when bulk-converting to test billing. */
export type SourceOrderTestBillingUpdate = {
    discount: number;
    itemsCost: number;
    gstBill: string;
    totalCost: number;
    selectedPayment: string;
    isGstBill: boolean;
    gstData: Record<string, number>;
    cart: Record<string, unknown>;
};

const SOURCE_ORDER_TEST_BILLING_CART: Record<string, unknown> = {
    'add-ons-water-bottle-18': {
        selectedVariants: {
            label: '₹18 / Unit',
            value: '18',
        },
        available: true,
        category: 'add-ons',
        customGST: '0',
        image: '',
        name: 'water-bottle',
        variants: null,
        type: 'veg',
        selected: 1,
        hsnCode: '2201',
        order: 2,
    },
};

/** Fixed field-level patch for the source order when bulk-converting to test billing. */
export const buildSourceOrderTestBillingUpdate = (): SourceOrderTestBillingUpdate => ({
    discount: 0,
    itemsCost: 18,
    gstBill: '',
    totalCost: 18,
    selectedPayment: 'cash',
    isGstBill: true,
    gstData: { '0': 0, '5': 0 },
    cart: SOURCE_ORDER_TEST_BILLING_CART,
});

const SOURCE_ORDER_WATER_BOTTLE_CART_KEY = 'add-ons-water-bottle-18';

/** True when the source order already has the test-billing patch applied. */
export const isSourceOrderTestBillingPatched = (orderData: DocumentData): boolean => {
    const cart = orderData?.cart as Record<string, unknown> | undefined;
    return (
        orderData?.itemsCost === 18 &&
        orderData?.totalCost === 18 &&
        orderData?.selectedPayment === 'cash' &&
        orderData?.isGstBill === true &&
        !!cart?.[SOURCE_ORDER_WATER_BOTTLE_CART_KEY]
    );
};

export type BulkTestBillingProgressPhase =
    | 'fetch'
    | 'copy'
    | 'patch'
    | 'skip'
    | 'error'
    | 'done';

export type BulkTestBillingProgressEvent = {
    orderId: string;
    index: number;
    total: number;
    phase: BulkTestBillingProgressPhase;
    message?: string;
    copyDocId?: string;
};

export type BulkTestBillingResult = {
    updatesByOrderId: Record<string, SourceOrderTestBillingUpdate>;
    summary: {
        total: number;
        succeeded: number;
        skipped: number;
        failed: number;
        errors: Array<{ orderId: string; message: string }>;
    };
};

export type BulkConvertOrdersToTestBillingOptions = {
    onProgress?: (event: BulkTestBillingProgressEvent) => void;
};

/**
 * For each food order: duplicate the document with isGstBill false, then patch the original
 * with only the test-billing source fields (other document keys stay intact).
 *
 * Copies are always created from the pre-patch snapshot. Already-patched sources are skipped
 * so re-runs do not create duplicate template copies.
 */
export const bulkConvertOrdersToTestBilling = async (
    orderIds: string[],
    options?: BulkConvertOrdersToTestBillingOptions
): Promise<BulkTestBillingResult> => {
    const uniqueOrderIds = Array.from(new Set((orderIds || []).filter(Boolean)));
    const total = uniqueOrderIds.length;
    const onProgress = options?.onProgress;

    const emptyResult = (): BulkTestBillingResult => ({
        updatesByOrderId: {},
        summary: { total: 0, succeeded: 0, skipped: 0, failed: 0, errors: [] },
    });

    if (!total) {
        return emptyResult();
    }

    const db = getFirestore();
    const updatesByOrderId: Record<string, SourceOrderTestBillingUpdate> = {};
    const errors: Array<{ orderId: string; message: string }> = [];
    let succeeded = 0;
    let skipped = 0;
    let failed = 0;

    for (let index = 0; index < uniqueOrderIds.length; index++) {
        const orderId = uniqueOrderIds[index];
        const emit = (phase: BulkTestBillingProgressPhase, extra?: Partial<BulkTestBillingProgressEvent>) => {
            onProgress?.({ orderId, index, total, phase, ...extra });
        };

        emit('fetch', { message: 'Loading order…' });

        try {
            const orderRef = doc(db, ordersCollectionName, orderId);
            const orderSnap = await getDoc(orderRef);

            if (!orderSnap.exists()) {
                skipped += 1;
                emit('skip', { message: 'Order not found — skipped' });
                continue;
            }

            const orderData = orderSnap.data();
            const sourceUpdate = buildSourceOrderTestBillingUpdate();

            if (isSourceOrderTestBillingPatched(orderData)) {
                skipped += 1;
                updatesByOrderId[orderId] = sourceUpdate;
                emit('skip', { message: 'Already converted — skipped' });
                continue;
            }

            // Snapshot before patch so copies never use the template fields.
            emit('copy', { message: 'Creating test-billing copy…' });
            const copyRef = await addDoc(collection(db, ordersCollectionName), {
                ...orderData,
                isGstBill: false,
            });

            emit('patch', { message: 'Updating source order…', copyDocId: copyRef.id });
            await updateDoc(orderRef, sourceUpdate);

            updatesByOrderId[orderId] = sourceUpdate;
            succeeded += 1;
            emit('done', { message: `Copy created (${copyRef.id})`, copyDocId: copyRef.id });
        } catch (error: unknown) {
            failed += 1;
            const message = error instanceof Error ? error.message : 'Unknown error';
            errors.push({ orderId, message });
            emit('error', { message });
        }
    }

    return {
        updatesByOrderId,
        summary: { total, succeeded, skipped, failed, errors },
    };
};

/**
 * Fetch a single room-bill document by Firestore id (orderId). Used when opening the
 * guest modal so the form shows server state, not a potentially stale list snapshot.
 */
export const fetchRoomBillById = async (
    orderId: string | undefined
): Promise<DocumentData | null> => {
    if (!orderId) {
        return null;
    }
    const db = getFirestore();
    try {
        const docSnap = await getDoc(doc(db, roomBillsCollectionName, orderId));
        if (!docSnap.exists()) {
            return null;
        }
        return { ...docSnap.data(), orderId: docSnap.id };
    } catch (error: unknown) {
        console.error("fetchRoomBillById", error);
        return null;
    }
};

/**
 * Load room-bills for a restaurant in a createdAt range without updating Redux.
 * Used by availability UI; keeps the same query shape as getRoomBillsList (range mode).
 */
export const fetchRoomBillsInRange = async (
    restaurantId: string | undefined,
    startDate: Date,
    endDate: Date
): Promise<DocumentData[]> => {
    if (!restaurantId) {
        return [];
    }
    const db = getFirestore();
    const start = moment(startDate).startOf('day').utc().valueOf();
    const end = moment(endDate).endOf('day').utc().valueOf();
    try {
        const q = query(
            collection(db, roomBillsCollectionName),
            where('restaurantId', '==', restaurantId),
            where('createdAt', '>=', start),
            where('createdAt', '<=', end),
            orderBy('createdAt', 'desc'),
        );
        const querySnapshot = await getDocs(q);
        const data: DocumentData[] = [];
        querySnapshot.forEach((docSnap) => {
            data.push({ ...docSnap.data(), orderId: docSnap.id });
        });
        return data;
    } catch (error: unknown) {
        console.error('fetchRoomBillsInRange', error);
        return [];
    }
};

export const getRoomBillsList = async (role: any, filterId: any, dispatch: any, filter?: any) => {
    // console.log(role, filterId);
    const db = getFirestore();
    try {
        let data: DocumentData[] = [];

        if (filterId) {
            const isRangeFilter =
                filter &&
                typeof filter === 'object' &&
                filter?.type === 'range' &&
                filter?.startDate &&
                filter?.endDate;

            let q;

            if (isRangeFilter) {
                const start = moment(filter.startDate).startOf('day').utc().valueOf();
                const end = moment(filter.endDate).endOf('day').utc().valueOf();

                q = query(
                    collection(db, roomBillsCollectionName),
                    where(role === 'admin' ? "restaurantId" : "userId", "==", filterId),
                    where("createdAt", ">=", start),
                    where("createdAt", "<=", end),
                    orderBy("createdAt", "desc"),
                );
            } else {
                const days = typeof filter === 'number' ? filter : undefined;
                const endDate = moment().subtract(role === 'admin' ? days || 5 : days || 30, 'days').utc().valueOf();

                q = query(
                    collection(db, roomBillsCollectionName),
                    where(role === 'admin' ? "restaurantId" : "userId", "==", filterId),
                    where("createdAt", ">=", endDate),
                    orderBy("createdAt", "desc"),
                );
            }

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                // data.docId = doc.id || null;
                data.push({ ...doc.data(), orderId: doc.id });
            });
            // console.log('data block--', data);
            // data = querySnapshot && querySnapshot[0] && querySnapshot[0].data() || {};
            if (data && data.length) {
                dispatch(updatedRoomBills(data));
            } else {
                dispatch(updatedRoomBills([]));
            }
        }
        // console.log("data => sign In after", querySnapshot, data);
        // history.push('/');
        // return data;
        // dispatch(updateReqData(data));
    } catch (error: any) {
        console.error("Error adding document: ", error);
        dispatch(logError({ severity: 'error', message: error?.message }));
    }
}
